const styles = theme => ({
  card: {
    display: 'flex',
    maxWidth: 400,
  },
  masterCard: {
    marginBottom: 18,
    width: 'calc(100% - 12px)',
    height: 208,
    maxWidth: 480,
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 151,
    height: 151,
  },
  demo: {
    padding: 0,
    marginLeft:0,
    position: 'absolute',
  },
  demo2: {
    padding: 4,
    marginLeft:12
  },
  demo3: {
    padding: 6,
    marginLeft:20
  },
  demo4: {
    padding: 9,
    marginLeft:20
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ActionsDrawer/components/CandidateItem/styles.js